<template>
  <div>
    <div class="title">发票类型及税点？</div>
    <div class="content-info">
      <p class="txt1">发票类型分为“增值税发票”和“普通发票”，商户不需要支付任何税点。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
